import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  PriceWidgetTypes,
  DepartureWidgetTypes,
  AmenitiesWidgetTypes,
  FlightDurationWidgetTypes
} from '@flight-results/entities/widget';
import { 
  FilterTypes, 
  StopTypes, 
  AirPriceRangeTypes, SectorTypes, 
} from '@shared/flight-itinerary/entities/filters';

export const MULTIPLE_CARRIERS = 'MultipleCarriers';
export const MULTIPLES = 'multiple';

export const BAGGAGE = 'BAGGAGE';
export const FLEX = 'FLEX';

export const BY_SECTOR_ITINERARY_SELECTED = 'by_sector_itinerary_selected';

export const FILTER_TITLES = {
  [FilterTypes.Stops]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.SCALE',
  [FilterTypes.Airlines]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.AEROLINE',
  [FilterTypes.PriceRange]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.PRICE',
  [FilterTypes.Alliances]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.ALLIANCES',
  [FilterTypes.AirPriceRanges]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.ITINERARY_PRICE',
  [FilterTypes.SectorDurations]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.FLIGHT_DURATION_SHORT',
  [FilterTypes.DepartureTimes]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.FLIGHT_DEPARTURE_SHORT',
  [FilterTypes.ArrivalAirports]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.FLIGHT_ARRIVAL_AIRPORT',
  [FilterTypes.DepartureAirports]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.FLIGHT_DEPARTURE_AIRPORT',
  [FilterTypes.Tags]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.TAGS',
};

export const AIRLINES_PRICES_TITLES = {
  [MULTIPLE_CARRIERS]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.MULTIPLE_CARRIERS'
};

export const SECTOR_TITLES = {
  [SectorTypes.Sector1]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.SECTORS.SECTOR_ONE',
  [SectorTypes.Sector2]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.SECTORS.SECTOR_TWO'
};

export const STOP_TITLES = {
  [StopTypes.Stops0]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.SCALE_FILTER.FILTER_DIRECT',
  [StopTypes.Stops1]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.SCALE_FILTER.JUST_ONE_SCALE',
  [StopTypes.Stops2]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.SCALE_FILTER.MORE_ONE_SCALE'
};

export const AIR_PRICE_RANGE_LABELS = {
  [AirPriceRangeTypes.PriceTo]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.OR_HIGHER',
  [AirPriceRangeTypes.PriceFrom]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.LOWER_TO'
};

export const DEPARTURE_WIDGET_LABELS = {
  [DepartureWidgetTypes.Morning]: 'GENERAL_WIDGET_MODULE.DEPARTURE_WIDGET.TYPES.MORNING',
  [DepartureWidgetTypes.Afternoon]: 'GENERAL_WIDGET_MODULE.DEPARTURE_WIDGET.TYPES.AFTERNOON',
  [DepartureWidgetTypes.Evening]: 'GENERAL_WIDGET_MODULE.DEPARTURE_WIDGET.TYPES.EVENING'
};

export const DEPARTURE_WIDGET_ICONS = {
  [DepartureWidgetTypes.Morning]: Icon.Morning,
  [DepartureWidgetTypes.Afternoon]: Icon.Afternoon,
  [DepartureWidgetTypes.Evening]: Icon.Evening
};

export const AMENITIES_WIDGET_LABELS = {
  [AmenitiesWidgetTypes.Wifi]: 'GENERAL_WIDGET_MODULE.AMMENITIES_WIDGET.TYPE.WIFI.TITLE',
  [AmenitiesWidgetTypes.Gym]: 'GENERAL_WIDGET_MODULE.AMMENITIES_WIDGET.TYPE.GYM.TITLE',
  [AmenitiesWidgetTypes.Pool]: 'GENERAL_WIDGET_MODULE.AMMENITIES_WIDGET.TYPE.POOL.TITLE',
  [AmenitiesWidgetTypes.Parking]: 'GENERAL_WIDGET_MODULE.AMMENITIES_WIDGET.TYPE.PARKING.TITLE'
};

export const AMENITIES_WIDGET_ICONS = {
  [AmenitiesWidgetTypes.Wifi]: Icon.Wifi,
  [AmenitiesWidgetTypes.Gym]: Icon.Gym,
  [AmenitiesWidgetTypes.Pool]: Icon.Pool,
  [AmenitiesWidgetTypes.Parking]: Icon.Parking
};

export const PRICE_WIDGET_LABELS = {
  [PriceWidgetTypes.Cheap]: 'GENERAL_WIDGET_MODULE.PRICE_WIDGET.TYPES.CHEAP',
  [PriceWidgetTypes.Middle]: 'GENERAL_WIDGET_MODULE.PRICE_WIDGET.TYPES.MIDDLE',
  [PriceWidgetTypes.High]: 'GENERAL_WIDGET_MODULE.PRICE_WIDGET.TYPES.HIGH'
};

export const PRICE_WIDGET_ICONS = {
  [PriceWidgetTypes.Cheap]: Icon.MoneyIcon,
  [PriceWidgetTypes.Middle]: Icon.IntermediatePrice,
  [PriceWidgetTypes.High]: Icon.Expensive
};

export const SECTOR_DURATIONS_LABELS = {
  [FlightDurationWidgetTypes.Low]: 'GENERAL_WIDGET_MODULE.SECTOR_DURATION_WIDGET.TYPES.LOW',
  [FlightDurationWidgetTypes.Intermediate]: 'GENERAL_WIDGET_MODULE.SECTOR_DURATION_WIDGET.TYPES.INTERMEDIATE',
  [FlightDurationWidgetTypes.High]: 'GENERAL_WIDGET_MODULE.SECTOR_DURATION_WIDGET.TYPES.HIGH'
};

export const SECTOR_DURATIONS_ICONS = {
  [FlightDurationWidgetTypes.Low]: Icon.Low,
  [FlightDurationWidgetTypes.Intermediate]: Icon.Medium,
  [FlightDurationWidgetTypes.High]: Icon.High
};

export const FILTER_BAR_ICON = {
  [FilterTypes.Stops]: Icon.ArrowRight,
  [FilterTypes.DepartureTimes]: Icon.Clock,
  [FilterTypes.SectorDurations]: Icon.DepartureDuration,
  [FilterTypes.PriceRange]: Icon.Monetization,
};
